// extracted by mini-css-extract-plugin
export default {"buttonStyles":"styles_buttonStyles__FmeoW"};